<template>
    <div class="main-layout">
        <div class="container is-fluid">
            <section class="section">
                <h2 class="title">{{ $t("admin.title") }}</h2>

                <div class="columns">
                    <div class="column is-3">
                        <div class="field">
                            <label class="label">{{ $t("misc.name") }}</label>
                            <div class="control">
                                <input class="input" v-model="newUser.name" type="text"
                                    :placeholder="$t('misc.namePlaceholder')">
                            </div>
                        </div>
                    </div>

                    <div class="column is-3">
                        <div class="field">
                            <label class="label">{{ $t("misc.surname") }}</label>
                            <div class="control">
                                <input class="input" v-model="newUser.surname" type="text"
                                    :placeholder="$t('misc.surnamePlaceholder')">
                            </div>
                        </div>
                    </div>

                    <div class="column">
                        <div class="field">
                            <label class="label">{{ $t("misc.email") }}</label>
                            <div class="control">
                                <input class="input" v-model="newUser.email" type="text"
                                    :placeholder="$t('misc.email')">
                            </div>
                        </div>
                    </div>
                </div>

                <hr />

                <b-button @click="inviteUser" class="is-primary">
                    {{ $t("admin.inviteButtonText") }}
                </b-button>
            </section>

            <section class="section">
                <h2 class="title">{{ $t("admin.users") }}</h2>

                <UsersList @deleteUser="this.deleteUser" :users="users" />
            </section>
        </div>
    </div>
</template>

<script>

const axios = require('axios');

import shared from '@/utils.js';
import UsersList from "@/components/admin/UsersList.vue";

export default {
    name: "Admin",
    components: {
        UsersList
    },
    data: function () {
        return {
            api: axios.create({
                baseURL: process.env.VUE_APP_JOBS_API_ROOT,
                headers: { Authorization: `Bearer ${localStorage.backendToken}` }
            }),
            users: [],
            newUser: {
                name: null,
                surname: null,
                email: null
            }
        }
    },
    methods: {
        getUsers() {
            let view = this;

            this.api.get("users").then(function (response) {
                view.users = response.data.users;
            }).catch(function () {
                view.$buefy.toast.open({
                    message: view.$t("admin.userLoadingError"),
                    type: "is-danger"
                })
            })
        },
        deleteUser(user) {
            let view = this;

            let confirmMessage = this.$t("admin.confirmDeletion", {
                name: user.name,
                username: user.username
            })

            if (confirm(confirmMessage)) {
                this.api.post(`delete-user/${user.id}`).then(function (response) {
                    if (response.status == 200) {
                        view.$buefy.toast.open({
                            message: view.$t("admin.userDeleted"),
                            type: "is-success"
                        })

                        view.users = view.users.filter(u => {
                            return u.id != response.data.id;
                        });
                    }
                }).catch(function () {
                    view.$buefy.toast.open({
                        message: view.$t("admin.userDeletedError"),
                        type: "is-danger"
                    })
                })
            }
        },
        inviteUser() {
            let view = this;

            this.api.post("invite-user", this.newUser).then(function (response) {
                if (response.status == 200) {
                    view.$buefy.toast.open({
                        message: view.$t("admin.invitationSent"),
                        type: "is-success"
                    });

                    view.users.push(response.data.user);
                    view.newUser = {
                        name: null,
                        surname: null,
                        email: null
                    }
                }
            }).catch(function () {
                view.$buefy.toast.open({
                    message: view.$t("admin.invitationError"),
                    type: "is-danger"
                });
            })
        }
    },
    mounted: function () {
        this.getUsers();

        let view = this;
        shared.getCurrentUser(function (user) {
            if (user.role != "admin") {
                // Redirect the user to the dashboard if
                // he/she is not an admin
                view.$router.push({
                    name: "dashboard"
                })
            }
        }, function (err) {
            console.log(err);
        });
    }
};

</script>

<style scoped>
@media only screen and (max-width: 768px) {
    .button {
        width: 100%;
    }
}
</style>